import {useState, ReactNode} from 'react'

export interface Item {
  label: string,
  content: ReactNode
}

interface StepOptions {
  items: Item[];
}

export const useStep = ({ items }: StepOptions) => {
  const [step, setStep] = useState(0);

  const nextStep = () => {
    setStep(step + 1);
  };

  const prevStep = () => {
    setStep(step - 1);
  };

  const goStep = (newStep) => {
    setStep(newStep);
  };

  const hasPrev = step > 0;

  const hasNext = step < items.length - 1;

  const current = items[step];

  const newItems = items.map((item, idx) => {
    return {...item, isCurrent: idx === step}
  })

  return {
    items: newItems,
    step,
    current,
    hasPrev,
    hasNext,
    nextStep,
    prevStep,
    goStep
  };
}
